"use client";
import React, { Fragment } from "react";
import { SlArrowRight } from "react-icons/sl";
import Link from "next/link";
import { usePathname } from "next/navigation";

const Breadcrumbs = () => {
  const pathname = usePathname();
  const breadcrumbs = pathname.split("/").filter(Boolean);
  let newPathName = [];

  return (
    <div className="breadcrumbs">
      <Link href="/">Startseite</Link>
      <SlArrowRight size={10} />
      {breadcrumbs.map((breadcrumb, index) => {
        newPathName.push(breadcrumb);
        const crumbName = decodeURIComponent(breadcrumb).replace(/^\d+/, "");
        return (
          <Fragment key={index}>
            <Link href={`/${newPathName.join('/')}`}>{crumbName.replace(/-/g, " ")}</Link>
            {index < breadcrumbs.length - 1 && <SlArrowRight size={10} />}
          </Fragment>
        );
      })}
    </div>
  );
};

export default Breadcrumbs; 